<div class="search-box-container">
  <div class="content" [formGroup]="form">
    <div class="input">
      <div class="search-icon" (click)="routeToSearchPage()">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
          <path fill="#222" fill-rule="evenodd"
                d="M17.63 14.456l-4.652-4.631c.377-.818.593-1.724.593-2.682 0-3.544-2.884-6.429-6.428-6.429S.714 3.6.714 7.143c0 3.544 2.885 6.428 6.429 6.428.958 0 1.864-.216 2.682-.593l4.652 4.631c.417.418.966.627 1.515.627.548 0 1.097-.209 1.515-.627l.122-.123c.836-.835.836-2.195 0-3.03zM2.142 7.143c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5zm14.459 9.345l-.114.114c-.257.257-.675.257-.933 0l-4.474-4.475c.391-.304.742-.655 1.046-1.046l4.475 4.474c.257.258.257.676 0 .933z" />
        </svg>
      </div>
      <div class="searchBox" #inputField>
        <!--Todo realize  autofocus-->
        <kion-input
          controlName="search"
          [placeHolder]="'search.placeHolder' | translate"
          id="search"
          [form]="form"
          (keydown.enter)="routeToSearchPage()"
          (init)="checkInput()"
        ></kion-input>
      </div>
      <div class="icons" *ngIf="form.valid">
        <div class="clear" (click)="clearForm()">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M9.933 1.076L8.923 0.066 5 3.99 1.077 0.066 0.067 1.076 3.99 5 0.067 8.924 1.077 9.934 5 6.01 8.923 9.934 9.933 8.924 6.01 5z" transform="translate(5 5)"></path>
          </svg>
        </div>
        <div class="go" (click)="routeToSearchPage()">
          <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>3FAA7269-52EB-46F2-9DBE-C31C4BD711A8</title>
            <g id="Styles" stroke="none" stroke-width="1" fill="#444" fill-rule="evenodd">
              <g id="Buttons" transform="translate(-434.000000, -1848.000000)" fill="#222222">
                <g id="Group-3" transform="translate(380.000000, 1848.000000)">
                  <g id="atom/icon/LMH-Icon-Arrow-Right-Black" transform="translate(54.000000, 0.000000)">
                    <g id="lmh-icon-arrow-right-black" transform="translate(1.428571, 3.571429)">
                      <polygon id="Path" points="11.2192857 0.209285714 10.2092857 1.21928571 14.7042857 5.71428571 0 5.71428571 0 7.14285714 14.7042857 7.14285714 10.2092857 11.6378571 11.2192857 12.6478571 17.4385714 6.42857143"></polygon>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
  <div class="search-result-container" *ngIf="(total$ | async) && (total$ | async) > 0">

    <div class="products">
      <div class="header">
        {{ 'search.products.headline' | translate:{count: total$ | async} }}
      </div>
      <a [customRouterLink]="getProductLink(product)" class="product" *ngFor="let product of results$ | async">
        <img class="searchListImage default" width="80px" height="80px" [lazyLoad]="product?.images[0]?.url + '?width=50&height=50padColor=fff'" [defaultImage]="product?.images[0]?.url + '?width=80&height=80padColor=fff'" errorImage="./assets/ui/shared/error/not_found_error_image.png"  />
        <div class="searchListName">{{product.name}} </div>
        <div class="searchListLink">
          <span>
            <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>3FAA7269-52EB-46F2-9DBE-C31C4BD711A8</title>
            <g id="Styles" stroke="none" stroke-width="1" fill="#444" fill-rule="evenodd">
              <g id="Buttons" transform="translate(-434.000000, -1848.000000)" fill="#222222">
                <g id="Group-3" transform="translate(380.000000, 1848.000000)">
                  <g id="atom/icon/LMH-Icon-Arrow-Right-Black" transform="translate(54.000000, 0.000000)">
                    <g id="lmh-icon-arrow-right-black" transform="translate(1.428571, 3.571429)">
                      <polygon id="Path" points="11.2192857 0.209285714 10.2092857 1.21928571 14.7042857 5.71428571 0 5.71428571 0 7.14285714 14.7042857 7.14285714 10.2092857 11.6378571 11.2192857 12.6478571 17.4385714 6.42857143"></polygon>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          </span>
        </div>
      </a>
    </div>
    <div class="footer">
      <div class="result-info">
        <div (click)="routeToSearchPage()">{{ 'search.results.result' | translate:{count: total$ | async} }}</div>
      </div>
    </div>
  </div>
</div>
